<template>
  <div>
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i
            class="fa fa-puzzle-piece"
            style="font-size: 62px; color: #d14d65"
          ></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compCarbonDocsWhy.text-1')"
          />
        </div>
      </div>
    </article>
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i
            class="fa fa-object-group"
            style="font-size: 50px; color: #8a4869"
          ></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compCarbonDocsWhy.text-2')"
          />
        </div>
      </div>
    </article>
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i class="fa fa-hubzilla" style="font-size: 62px; color: #5f548d"></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compCarbonDocsWhy.text-3')"
          />
        </div>
      </div>
    </article>
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i class="fa fa-tags" style="font-size: 52px; color: #3b589f"></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compCarbonDocsWhy.text-4')"
          />
        </div>
      </div>
    </article>
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i class="fa fa-podcast" style="font-size: 62px; color: #0d7eb6"></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compCarbonDocsWhy.text-5')"
          />
        </div>
      </div>
    </article>
    <br />
  </div>
</template>

<script>
export default {
  name: 'Why'
}
</script>

<style lang="css">
article {
  border: 0px;
}
</style>
